import React, { useState, useEffect } from "react";
import BASE_URL from "components/BaseUrl/apiConfig";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import AnimatedCard from "react-animated-3d-card";
import CardStats from "components/Cards/CardStats.js";
import CardStats1 from "components/Cards/CardStats1.js";
import SummaryCard from "components/Cards/SummaryCard";
import QuantityImage from "assets/img/QuantityManagement.jpg";
import NotesImage from "assets/img/NotesManagement.jpg";
import DocumentImage from "assets/img/DocumentLibrarayManagement.jpg";
import MarketingImage from "assets/img/EmailMarketing.jpg";
import ExpenseImage from "assets/img/ExpensesManagement.jpg";

export default function HeaderStats() {
  const quantityTracking =
    "https://img.freepik.com/free-vector/charts-concept-illustration_114360-91.jpg?t=st=1722489740~exp=1722493340~hmac=4ab0d6451c3925457a2413d1df21073b1633390f1c83471df1447ae6ff1aa781&w=740";

  const imageExpenseTracking =
    "https://img.freepik.com/free-vector/bill-analysis-concept-illustration_114360-22918.jpg?t=st=1722490505~exp=1722494105~hmac=bdeae48963705d1e2cc43ccac5ef790897bf82b18de10be832b91d8b4caf6c26&w=740";

  const notesimage =
    "https://img.freepik.com/free-vector/hand-drawn-essay-illustration_23-2150268421.jpg?t=st=1722490677~exp=1722494277~hmac=35e42c5169dacbcf6fdab87fc7a11bdb9ea640791dcc6b44b335b0ded97d096b&w=740";

  const documentimg =
    "https://img.freepik.com/free-vector/app-data-concept-illustration_114360-4423.jpg?t=st=1722490797~exp=1722494397~hmac=1225b73792fe4533d7e02d871c2ad9cdb360133f8ec390d7c6c139eb2e6f2662&w=740";

  const marketingimg =
    "https://img.freepik.com/premium-vector/passive-income-abstract-concept-vector-illustration_107173-24812.jpg?w=740";

  const history = useHistory(); // Get the history object
  const [currency, setCurrency] = useState("");
  const [count, setCount] = useState("");
  const [totalBalance, setTotalBalance] = useState({});

  //get userid form loca storage
  const storedUserData = localStorage.getItem("userData");
  let userId = "";
  let groupId = "";
  if (storedUserData) {
    const userData = JSON.parse(storedUserData);
    userId = userData.userId;
    groupId = userData.groupId;
  }

  //Fetch all data in parallel
  useEffect(() => {
    const fetchData = async () => {
      try {
        const [balanceResponse, currencyResponse, messageCountResponse] =
          await Promise.all([
            fetch(`${BASE_URL}/api/Expense/GetTotalBalance?groupId=${groupId}`),
            fetch(
              `${BASE_URL}/api/Users/GetCurrencyByUserId?groupId=${groupId}`
            ),
            fetch(
              `${BASE_URL}/api/Expense/MessageCountByGroupID?GroupID=${groupId}`
            ),
          ]);

        const balanceData = await balanceResponse.json();
        const currencyData = await currencyResponse.json();
        const messageCountData = await messageCountResponse.json();

        setTotalBalance(balanceData);
        setCurrency(currencyData.currency);
        setCount(messageCountData);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [groupId]);

  // Check if availableBalance is greater than 0
  const isPositiveBalance = totalBalance.availableBalance > 0;

  // Set the color dynamically based on the condition
  const balanceColor = isPositiveBalance ? "rgb(0, 0, 255)" : "red";

  const OnQuantityTrackingClick = () => {
    history.push("/getQuantityTraking");
  };
  const OnMarketingClick = () => {
    history.push("/messageLogs");
  };

  const OnExpenseTrackingClick = () => {
    history.push("/expenses");
  };

  const OnNotesClick = () => {
    history.push("/notes");
  };

  const getDocument = () => {
    history.push("/getDocument");
  };

  return (
    <>
      {/* Header */}

      <div className="relative HeaderStats">
        <div className="mx-auto w-full">
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3 m-3">
            <div className="text-center">
              <SummaryCard totalBalance={totalBalance} currency={currency} />
            </div>
           
            <div className="bg-white-500 ">
              <div className="aminated-card h-full w-full">
              <div onClick={OnQuantityTrackingClick}>
                  <AnimatedCard
                    config={{
                      rotation: 30,
                      transformSpeed: 1000,
                      transitionSpeed: 600,
                    }}
                    style={{
                      width: "100%",
                      height: "100%",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                      borderRadius: "none",
                      borderRadius: "0.5rem",
                      padding: "8px 15px",
                    }}
                  >
                    <div className="text-center mt-3">
                      <div className="text-center mt-3">
                        <span className="text-xl block">Quantity</span>
                        <span className="text-xl block">Management</span>
                      </div>
                    </div>
                    {/* <h2 className="text-blueGray-700 text-xl font-semibold text-center pt-3 ">
                      Notes Management
                    </h2> */}
                    <img
                     src={QuantityImage}
                      alt="Quantity Tracking"
                      className="w-full h-auto object-cover pb-3"
                    />
                  </AnimatedCard>
                </div>
              </div>
            </div>
            <div className="bg-white-500 ">
              <div className="aminated-card h-full w-full">
                <div onClick={OnNotesClick}>
                  <AnimatedCard
                    config={{
                      rotation: 30,
                      transformSpeed: 1000,
                      transitionSpeed: 600,
                    }}
                    style={{
                      width: "100%",
                      height: "100%",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                      borderRadius: "none",
                      borderRadius: "0.5rem",
                      padding: "8px 15px",
                    }}
                  >
                    <div className="text-center mt-3">
                      <div className="text-center mt-3">
                        <span className="text-xl block">Notes</span>
                        <span className="text-xl block">Management</span>
                      </div>
                    </div>
                    {/* <h2 className="text-blueGray-700 text-xl font-semibold text-center pt-3 ">
                      Notes Management
                    </h2> */}
                    <img
                      src={NotesImage}
                      alt="Notes Management"
                      className="w-full h-auto object-cover pb-3"
                    />
                  </AnimatedCard>
                </div>
              </div>
            </div>
            <div className="bg-white-500 ">
              <div className="aminated-card">
                <div onClick={getDocument}>
                  <AnimatedCard
                    config={{
                      rotation: 30,
                      transformSpeed: 1000,
                      transitionSpeed: 600,
                    }}
                    style={{
                      width: "100%",
                      height: "100%",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                      borderRadius: "none",
                      borderRadius: "0.5rem",
                      padding: "8px 15px",
                    }}
                  >
                    <div className="text-center mt-3">
                      <span className="text-xl block">Documents</span>
                      <span className="text-xl block">Management</span>
                    </div>
                    {/* <h2 className="text-blueGray-700 text-xl font-semibold text-center pt-3">
                      Documents Management
                    </h2> */}
                    <img
                      src={DocumentImage}
                      alt="Document Management"
                      className="w-full h-auto object-cover pb-3"
                    />
                  </AnimatedCard>
                </div>
              </div>
            </div>
            <div className="bg-white-500 ">
              <div className="aminated-card">
                <div onClick={OnMarketingClick}>
                  <AnimatedCard
                    config={{
                      rotation: 30,
                      transformSpeed: 1000,
                      transitionSpeed: 600,
                    }}
                    style={{
                      width: "100%",
                      height: "100%",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                      borderRadius: "none",
                      borderRadius: "0.5rem",
                      padding: "8px 15px",
                    }}
                  >
                    <div className="text-center mt-3">
                      <span className="text-xl block">Marketing</span>
                      <span className="text-xl block">Management</span>
                    </div>
                    {/* <h2 className="text-blueGray-700 text-xl font-semibold text-center pt-3">
                      Marketing Management
                    </h2> */}
                    <img
                      src={MarketingImage}
                      alt="Marketing Management"
                      className="w-full h-auto object-cover pb-3"
                    />
                  </AnimatedCard>
                </div>
              </div>
            </div>
            {/* <div className="text-center shadow">
              <SummaryCard totalBalance={totalBalance} currency={currency} />
            </div> */}
          </div>
        </div>
      </div>

      {/* <div className="relative md:pt-8 pb-16 mt-4">
        <div className=" mx-auto w-full">
          <div className="flex flex-wrap">
            <div className="w-full lg:w-6/12 xl:w-3/12 px-4">
              <CardStats
                statSubtitle="Available Balance"
                statTitle={totalBalance.availableBalance}
                currency={currency}
                statPercentColor="text-emerald-500"
                statIconName="fas fa-balance-scale"
                statIconColor="bg-red-500"
              />
            </div>
            <div className="w-full lg:w-6/12 xl:w-3/12 px-4">
              <CardStats
                statSubtitle="Total Credited"
                statTitle={totalBalance.totalCreatedSum}
                currency={currency}
                statPercentColor="text-orange-500"
                statIconName="fas fa-balance-scale"
                statIconColor="bg-orange-500"
              />
            </div>
            <div className="w-full lg:w-6/12 xl:w-3/12 px-4">
              <CardStats
                statSubtitle="Total Debited"
                statTitle={totalBalance.totalDebitedSum}
                currency={currency}
                statPercentColor="text-red-500"
                statIconName="fas fa-balance-scale"
                statIconColor="bg-pink-500"
              />
            </div>
            <div className="w-full lg:w-6/12 xl:w-3/12 px-4">
              <CardStats1
                statSubtitle="Messages"
                statTitle={count.toString()}
                count={count}
                statPercentColor="text-fuchsia-500"
                statIconName="fas fa-balance-scale"
                statIconColor="bg-teal-500"
              />
            </div>
          </div>
        </div>
      </div> */}
    </>
  );
}
